import { Flex, Image } from "@qws-org/ui-kit";
import type { FC } from "react";

import { LocaleSelect } from "~/features/secondary-footer/components/LocaleSelect";
import type { SecondaryFooterProps } from "~/features/secondary-footer/SecondaryFooter";
import { useDirectus } from "~/shared/utils/directus/useDirectus";
import { getPictureData } from "~/shared/utils/get-picture-data";

export const FooterLogoAndLanguageSelect: FC<SecondaryFooterProps> = ({
  data,
}) => {
  const { getDirectusImage } = useDirectus();
  const footerLogo = getPictureData(data?.footer_logo);
  return (
    <Flex
      justify={"space-between"}
      width={"100%"}
      align={"center"}
      p={{ py: 24 }}
    >
      <Image
        value={getDirectusImage(footerLogo.id ?? "", {
          format: "webp",
          width: footerLogo.mWidth,
          height: footerLogo.mHeight,
        })}
        width={footerLogo.mWidth}
        height={footerLogo.mHeight}
        mdValue={getDirectusImage(footerLogo.mdId, {
          format: "webp",
          width: footerLogo.mdWidth,
          height: footerLogo.mdHeight,
        })}
        dValue={getDirectusImage(footerLogo.dId, {
          format: "webp",
          width: footerLogo.dWidth,
          height: footerLogo.dHeight,
        })}
        md={{ width: footerLogo.mdWidth, height: footerLogo.mdHeight }}
        d={{ width: footerLogo.dWidth, height: footerLogo.dHeight }}
      />

      <LocaleSelect
        languages={data.languages}
        availableLanguages={data.availableLanguages}
        language={data.language}
        hreflangAlternates={data.hreflangAlternates}
        isNonModal={false}
        variant="positioned"
        offset={2}
      />
    </Flex>
  );
};
